export default __webpack_public_path__ + "static/037-43b9ac5f4885161f589d28328e0522d6.png";